export default __webpack_public_path__ + "static/media/shopify-partner.c2dca737.svg";